import { AxiosRequestHeaders } from 'axios';
import { api } from '.';
import {CORRELATION_ID_KEY} from '../../hooks/useStartTransaction';

function getDefaultHeaders() {
    const headers: AxiosRequestHeaders = {} as AxiosRequestHeaders;
    const correlationId = sessionStorage.getItem(CORRELATION_ID_KEY);
    if (correlationId) {
        headers['correlationId'] = correlationId;
    }

    return headers;
}

const requestInter = () =>
    api.interceptors.request.use((config) => {
        config.headers = { ...config.headers, ...getDefaultHeaders() };
        return config;
    });

export default requestInter;
